import Icon from '../components/Icon.vue'

Icon.register({
  'smoking-ban': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M96 304v-64c0-8.8 7.2-16 16-16h21.5l96 96h-117.5c-8.8 0-16-7.2-16-16zM256 0c141.4 0 256 114.6 256 256s-114.6 256-256 256-256-114.6-256-256 114.6-256 256-256zM256 448c41.4 0 79.7-13.3 111.1-35.7l-267.4-267.4c-22.4 31.4-35.7 69.7-35.7 111.1 0 105.9 86.1 192 192 192zM301.2 256l32 32h50.8v-32h-82.8zM412.3 367.1c22.4-31.4 35.7-69.7 35.7-111.1 0-105.9-86.1-192-192-192-41.4 0-79.7 13.3-111.1 35.7l124.3 124.3h130.8c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-34.8zM320.6 128c32.1 0 58.7 23.7 63.3 54.6 0.7 4.9-3 9.4-8 9.4h-16.2c-3.7 0-7-2.5-7.7-6.1-2.8-14.7-15.8-25.9-31.4-25.9-32.1 0-58.7-23.7-63.3-54.6-0.7-4.9 3-9.4 8-9.4h16.2c3.7 0 7 2.5 7.7 6.1 2.8 14.7 15.8 25.9 31.4 25.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/smoking-ban.js
// module id = 1907
// module chunks = 0